export default __webpack_public_path__ + "static/media/gift.542f073c.png";